module.exports = __webpack_public_path__ + "img/shield.a5d4ec5f.svg";